import {
    RwisStationActionTypes, AddRwisStations, ModifyRwisStations, DeleteRwisStations
} from './ActionTypes';
import { Station, Id } from 'NSwag/ServerClient/Client.nswag';

export const addRwisStations = (rwisStations: Station[]): AddRwisStations => ({
    type: RwisStationActionTypes.AddRwisStations as RwisStationActionTypes.AddRwisStations,
    rwisStations
});

export const modifyRwisStations = (rwisStations: Station[]): ModifyRwisStations => ({
    type: RwisStationActionTypes.ModifyRwisStations as RwisStationActionTypes.ModifyRwisStations,
    rwisStations
});

export const deleteRwisStations = (ids: Id[]): DeleteRwisStations => ({
    type: RwisStationActionTypes.DeleteRwisStations as RwisStationActionTypes.DeleteRwisStations,
    ids
});

export type RwisStationAction = ReturnType<typeof addRwisStations| typeof modifyRwisStations | typeof deleteRwisStations >